<script setup lang="ts">
import logoImage from '@/assets/images/top-speakers/logo.svg?url';

const topSpeakers = await queryContent('/top-speakers').findOne();
</script>

<template>
  <section id="speakers-section" class="speakers">
    <div class="speakers__container container">
      <h2 class="speakers__title text-40">{{ topSpeakers.title }}</h2>
      <div class="speakers__list">
        <div v-for="(item, index) in topSpeakers.list" :key="index" class="speakers__item">
          <NuxtImg
            :src="item.image"
            alt="Фото"
            class="speakers__photo"
            loading="lazy"
            format="webp"
          />
          <div class="speakers__text-wrapper">
            <h3 class="speakers__name text-22">{{ item.title }}</h3>
            <p class="speakers__position text-20">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <img class="speakers__logo" :src="logoImage" alt="Логотип" loading="lazy">
  </section>
</template>

<style scoped lang="scss">
.speakers {
  padding-top: 60px;
  padding-bottom: 88px;
  background-color: #E5F0F4;
  position: relative;

  @media (max-width: $large) {
    padding-top: 48px;
    padding-bottom: 72px;
  }

  @media (max-width: $medium) {
    padding-top: 30px;
  }

  @media (max-width: $mobile) {
    padding-bottom: 36px;
  }

  &::after {
    content: '';
    width: 38.5%;
    height: 100%;
    background-color: var(--success-color);
    border-radius: 0 30px 30px 0;
    position: absolute;
    top: 0;
    left: 0;

    @media (max-width: $medium) {
      width: 100%;
      border-radius: 0;
    }
  }

  &__logo {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  &__container {
    position: relative;
    z-index: 1;
  }

  &__text-wrapper {
    padding: 28px 29px 36px 40px;

    @media (max-width: $large) {
      padding: 16px 20px 16px 24px;
    }

    @media (max-width: $medium) {
      padding: 10px 20px 16px 24px;
    }

    @media (max-width: $mobile) {
      padding: 16px 20px 16px 24px;
    }
  }

  &__title {
    margin-bottom: 58px;
    color: white;
    max-width: 400px;

    @media (max-width: $medium) {
      max-width: 100%;
      margin-bottom: 34px;
    }
  }

  &__list {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(2, 1fr);

    @media (max-width: $small) {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      justify-content: center;
      gap: 15px;
    }
  }

  &__item {
    max-width: 410px;
    background: #fff;
    border-radius: 20px;
  }

  &__photo {
    width: 100%;
    border-radius: 20px 20px 0 0;
    height: 380px;
    object-fit: cover;

    @media (max-width: $large) {
      height: 260px;
    }

    @media (max-width: $medium) {
      height: 220px;
    }

    @media (max-width: $medium) {
      height: 260px;
    }
  }

  &__name {
    margin-bottom: 16px;
    color: var(--dark-color);

    @media (max-width: $medium) {
      line-height: 1.4;
    }

    @media (max-width: $mobile) {
      font-size: 18px;
    }

    @media (max-width: $mobile) {
      margin-bottom: 12px;
    }
  }

  &__position {
    color: var(--dark-color);
  }
}
</style>
